import { render, staticRenderFns } from "./horizontalNav.vue?vue&type=template&id=5160362c&scoped=true"
import script from "./horizontalNav.vue?vue&type=script&lang=js"
export * from "./horizontalNav.vue?vue&type=script&lang=js"
import style0 from "./horizontalNav.vue?vue&type=style&index=0&id=5160362c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160362c",
  null
  
)

export default component.exports